export default {
  methods: {
    goToPainel({ vod_id, id }) {
      if (vod_id) {
        this.$root.$emit('changeNavItem', 0)
      } else {
        this.$root.$emit('changeNavItem', 3)
      }
      this.$router.push({ name: 'NewLiveV2', params: { id } })
    },
  },
}
